import type { ComponentContentSchema } from '@vibesites/runtime';
import {
  useBlockSlot,
  SectionContextProvider,
  EditableToken,
} from '@vibesites/runtime/react';

/**
 * Working availability embed for the Interactive Map page.
 *
 * Repli's apartment-sync-map shortcode never receives a SightMap URL for
 * this property (`i_url` is empty), so the editor-injected map block sits
 * on its loading GIF forever. This section hides that stuck loader and
 * renders the ApartmentSync floorplan widget instead.
 */
export function InteractiveMapSection() {
  const blockSlot = useBlockSlot('interactivemapsection.block', {
    defaultValue: 'apartment-sync',
  });

  return (
    <section className="interactivemapsection bg-background">
      <EditableToken path="interactivemapsection.block" as="div" className="interactivemapsection__inner">
        {blockSlot ? (
          <SectionContextProvider sectionId={blockSlot.sectionId}>
            <blockSlot.BlockComponent sectionId={blockSlot.sectionId} />
          </SectionContextProvider>
        ) : (
          <div className="interactivemapsection__empty">No block selected</div>
        )}
      </EditableToken>

      <style>{`
        #apartment-sync-map {
          display: none !important;
        }
        .interactivemapsection {
          width: 100%;
          min-height: 560px;
        }
        .interactivemapsection__inner {
          min-height: 560px;
        }
        .interactivemapsection__empty {
          font-family: var(--vibe-font-body);
          color: var(--vibe-color-text-muted);
          text-align: center;
          padding: 2rem 1rem;
        }
      `}</style>
    </section>
  );
}

export const contentSchema: ComponentContentSchema = {
  slot: 'InteractiveMapSection',
  displayName: 'Interactive Map Section',
  tokens: {
    'interactivemapsection.block': {
      label: 'Block',
      type: 'block',
      defaultValue: 'apartment-sync',
      acceptedBlockCategories: ['Integrations', 'Embeds'],
    },
  },
};

(InteractiveMapSection as unknown as { contentSchema: ComponentContentSchema }).contentSchema = contentSchema;

export default InteractiveMapSection;
